import React from 'react'
import { Col } from 'react-bootstrap'
import './styles.scss'
import { enablePlpRedesign } from 'src/utils'

class ProductsPlaceHolder extends React.PureComponent {
  render() {
    const defaultColumnType = enablePlpRedesign()
      ? { xs: '12', md: '4', lg: '3' }
      : { xs: '6', md: '4', lg: '3' }
    const {
      products = [],
      columnType = defaultColumnType,
      containerClsName = 'mpp-placeholder',
      columnClassName = 'mb-2',
    } = this.props || {}

    if (products?.length <= 0) {
      return <></>
    }

    return (
      <div className={containerClsName}>
        {products.map((product, i) => (
          <Col {...columnType} key={i} className={columnClassName}>
            <div
              className="product-card"
              style={
                enablePlpRedesign()
                  ? {
                      display: 'flex',
                      flexDirection: window.innerWidth < 567 ? 'row' : 'column',
                      alignItems:
                        window.innerWidth < 567 ? 'flex-start' : 'center',
                      height: window.innerWidth < 567 ? '250px' : 'auto',
                      background: '#f5f5f5',
                    }
                  : {}
              }>
              <div
                className="image mb-2"
                style={
                  enablePlpRedesign()
                    ? {
                        width: window.innerWidth < 567 ? '90px' : '100%',
                        height: window.innerWidth < 567 ? '100%' : '210px',
                        minHeight: window.innerWidth < 567 ? '100%' : '210px',
                        marginBottom: window.innerWidth < 567 ? 0 : '8px',
                      }
                    : {}
                }></div>
              <div
                className="content"
                style={
                  enablePlpRedesign()
                    ? {
                        width:
                          window.innerWidth < 567
                            ? 'calc(100% - 90px)'
                            : '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                        padding:
                          window.innerWidth < 567 ? '32px 0 0 16px' : '0',
                        height: '100%',
                      }
                    : {}
                }>
                <h2
                  className="title"
                  style={
                    enablePlpRedesign()
                      ? { width: '70%', marginBottom: '16px' }
                      : {}
                  }></h2>
                <p
                  className="desc"
                  style={enablePlpRedesign() ? { width: '50%' } : {}}></p>

                <span className="out-of-stock-placeholder"></span>
                <span className="price-placeholder"></span>
                <span className="add-btn-placeholder"></span>
              </div>
            </div>
          </Col>
        ))}
      </div>
    )
  }
}

export { ProductsPlaceHolder }
export default ProductsPlaceHolder
